import React, { FC } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import Button from 'components/uiKit/Button'
import Loader from 'components/uiKit/Loader'
import { PATHS } from 'constants/paths'
import { useGetUserInfo } from 'gql/kusers/apollo'
import generateLink from 'routes/generateLink'

interface IPartaLoginProps {
  onContinue: (email: string, name?: string) => void
}

export const PartaLogin: FC<IPartaLoginProps> = ({ onContinue }) => {
  const location = useLocation()
  const history = useHistory()
  const { data: userData, loading } = useGetUserInfo()

  const currentUser = userData?.data

  const handleLogin = () => {
    const redirectLink = generateLink(PATHS.auth, {
      search: `?redirectTo=${encodeURIComponent(`${location.pathname}${location.search}`)}`,
    })
    history.push(redirectLink)
  }

  const handleContinueAsUser = () => {
    if (currentUser?.email) {
      onContinue(currentUser.email, currentUser.name || undefined)
    }
  }

  if (loading) {
    return <Loader name='partaLoginLoader' />
  }

  if (currentUser?.email) {
    return (
      <div style={{ textAlign: 'center' }}>
        <p style={{ color: 'var(--brand-secondaryTextColor)', marginBottom: '16px' }}>
          Continue as:
        </p>
        <div
          style={{
            padding: '16px',
            backgroundColor: 'var(--brand-primaryBackgroundColor)',
            borderRadius: '8px',
            marginBottom: '24px',
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: '4px' }}>
            {currentUser.name || currentUser.email}
          </div>
          {currentUser.name && (
            <div style={{ color: 'var(--brand-secondaryTextColor)', fontSize: '14px' }}>
              {currentUser.email}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Button name='continueAsUser' onClick={handleContinueAsUser}>
            Continue
          </Button>
          <Button name='switchAccount' onClick={handleLogin} styleType='secondary'>
            Switch account
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <p style={{ color: 'var(--brand-secondaryTextColor)', marginBottom: '24px' }}>
        Please log in to your account to access this content.
      </p>
      <Button name='partaLogin' onClick={handleLogin}>
        Log in
      </Button>
    </div>
  )
}
